<template>
  <div>
    <h5 class="message my-5">
      No cierre sesión o cambie de empresa mientras está en el proceso de enrolamiento
    </h5>
    <form data-vv-scope="data-form" @submit.prevent="solicitarVerificacionIdentidad">
      <div
        class="row">
        <div class="col-6">
          <label>Número de serie</label>
          <b-form-input
            v-model="serialNumber"
            id="serialNumber"
            name="serialNumber"
            data-vv-as="serialNumber"
            v-validate="'required'"
            :state="!this.errors.has('data-form.serialNumber')"
            placeholder="Ingrese su número de carnet"
          />
        </div>
      </div>
      <div
        class="row">
        <div class="col-6">
          <label>Comuna</label>
          <b-form-input
            v-model="commune"
            type="commune"
            id="commune"
            name="commune"
            data-vv-as="commune"
            v-validate="'required'"
            :state="!this.errors.has('data-form.commune')"
            placeholder="Ingrese Comuna"
          />
        </div>
      </div>
      <div
        class="row">
        <div class="col-6">
          <label>Correo</label>
          <b-form-input
            v-model="email"
            type="email"
            id="email"
            name="email"
            data-vv-as="email"
            v-validate="'required'"
            :state="!this.errors.has('data-form.email')"
            placeholder="Ingrese Correo"
          />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <b-button
            v-if="!loading"
            :title="'Solicitar código de verificación'"
            :disabled="isDisabled"
            variant="primary"
            @click="solicitarVerificacionIdentidad">
            Solicitando Verificación de identidad
          </b-button>
          <b-button
            v-if="loading"
            :title="'Solicitando código de verificación'"
            variant="primary"
          >
            Solicitando Verificación de identidad
            <b-spinner small v-if="loading" variant="info"/>
          </b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { configureSimpleAndEsign7Sign } from '@/febos/servicios/api/usuarios.api';

export default {
  name: 'ActivateEnrollment',
  components: {},
  props: ['user', 'signConfiguration'],
  data() {
    return {
      serialNumber: null,
      commune: 'Santiago',
      email: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    passwordStatus() {
      return {
        longitud: this.password && this.password.length >= 8,
        letraMinuscula: this.password && /[a-z]/.test(this.password),
        letraMayuscula: this.password && /[A-Z]/.test(this.password),
        numero: this.password && /\d/.test(this.password),
        caracterEspecial: this.password && /[!@#$%^&*().]/.test(this.password),
        iguales: this.password && this.passwordConfirmacion === this.password
      };
    },
    isDisabled() {
      if (!this.serialNumber) {
        return true;
      }
      if (!this.commune) {
        return true;
      }
      return false;
    },
    isValidOtp() {
      if (!this.sToken) {
        return false;
      }
      if (!this.otp) {
        return false;
      }
      if (this.otp.length < 5) {
        return false;
      }
      return true;
    }
  },
  methods: {
    activate() {
      this.$emit('activate', {});
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str)
        .replace(/[!'()]/g, escape)
        .replace(/\*/g, '%2A');
    },
    getAmbit() {
      const options = /cloud|proveedores|cliente/i;
      const defaultAmbit = 'cloud';
      try {
        const parts = window.location.href
          .replace('https://', '')
          .replace('http://', '')
          .split('/');
        if (parts[0].includes('localhost')) {
          return parts[2].match(options) ? parts[2] : defaultAmbit;
        }
        return parts[3].match(options) ? parts[3] : defaultAmbit;
      } catch (e) {
        return defaultAmbit;
      }
    },
    getBasePath() {
      const resultados = window.location.href
        .replace('https://', '')
        .replace('http://', '')
        .split('/');
      console.log(`RESULTADOS ${resultados}`);
      return resultados != null && resultados.length >= 0 ? resultados[0] : '';
    },
    async generarCertificado() {
      this.loading = true;
      const formCheck = await this.$validator.validateAll('data-form');
      if (formCheck) {
        const data = {
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros: {
            accion: 'GENERAR_CERT_CONFIRMAR',
            password: this.password,
            sToken: this.sToken,
            otp: this.otp
          },
          proveedor: 'ASignAPI',
          tipoFirma: 'firmaAvanzada'
        };
        try {
          const response = await configureSimpleAndEsign7Sign(data);
          this.sToken = response.data.parametros.sToken;
          this.activate();
          this.$refs.otpVerificacionModal.hide();
        } catch {
          this.loading = false;
          this.$refs.otpVerificacionModal.hide();
        }
      }
      this.loading = false;
    },
    async solicitarVerificacionIdentidad() {
      this.loading = true;
      this.sToken = null;
      const formCheck = await this.$validator.validateAll('data-form');
      if (formCheck) {
        const callback = `https://${this.getBasePath()}/${this.getAmbit()}/usuario/perfil/verificacion/asignapi?status=`;
        const data = {
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros: {
            accion: 'GENERAR_CERT',
            nombres: this.nombres,
            apellidos: this.apellidos,
            redirectUrl: `${callback}ok`,
            redirectUrlError: `${callback}error`,
            commune: this.commune,
            serialNumber: this.serialNumber,
            email: this.email
          },
          proveedor: 'ASignAPI',
          tipoFirma: 'firmaAvanzada'
        };
        try {
          const response = await configureSimpleAndEsign7Sign(data);
          this.sToken = response.data.parametros.sToken;
          const { sAuthUrl } = response.data.parametros;
          // open sAuthUrl
          window.open(sAuthUrl, '_self');
        } catch {
          this.loading = false;
        }
      }
      this.loading = false;
    }
  },
  mounted() {
    this.email = this.user.correo;
  }
};
</script>

<style scoped>
.container-pdf {
  height: 500px;
  overflow-y: auto;
  width: 100%;
}
</style>
